import { capitalize } from "es-toolkit/string";
import Pit from "src/business-components/Pit/Pit";
import StatusChip from "src/components/features/small/StatusChip/StatusChip";
import type { ColorKeys } from "src/theme";
import { RUN_STATUSES } from "../../RunsStatusBars.constants";
import type { Run } from "../../RunsStatusBars.types";
import RunStatusBar from "../RunStatusBar/RunStatusBar";

const RunStatusTooltip = ({ status, app_pit, last_run }: Partial<Run>) => (
  <div className="flex gap-3 items-stretch">
    <RunStatusBar status={status} className="h-auto" />

    <section className="flex flex-col gap-3 items-start">
      <StatusChip status={status as ColorKeys}>
        {status ? capitalize(RUN_STATUSES[status.toUpperCase()]) : "Unknown"}
      </StatusChip>

      <div className="leading-3">
        <div className="opacity-60">PIT</div>
        <Pit app_pit={app_pit || ""} last_run={last_run} />
      </div>

      <div className="text-xs text-text-secondary reveal">
        Click to explore pipeline run
      </div>
    </section>
  </div>
);

export default RunStatusTooltip;
